export enum DropdownNames {
  ACTIVITIES = 'activities',
  TERMINAL = 'terminal',
  TIME_ENTRIES = 'time_entries',
  ABSENCES = 'absences',
  ISSUES = 'issue_category_responsible',
  USER_DOCUMENT = 'responsible_user',
}
